import { DragOverlay } from '@dnd-kit/core';
import { DragObject } from '@lmt/unicorn-shared/app/components/calendar/devextreme/common';
import { VisitContent } from '@lmt/unicorn-shared/app/components/calendar/devextreme/components/VisitContent';
import React, { FC } from 'react';

import navTabStyles from '../../navigation/components/NavTab.module.scss';

interface Props {
  draggingTabData: DragObject | undefined;
}

export const UnicornDragOverlay: FC<Props> = (props) => {
  const { draggingTabData } = props;
  const Icon = draggingTabData?.iconComponent;

  return (
    <DragOverlay>
      {draggingTabData?.type == 'patient' && (
        <div className={navTabStyles.navTabContainerDrag}>
          {Icon && (
            <div className={navTabStyles.tabIconDrag}>
              <Icon />
            </div>
          )}
          <div className={navTabStyles.navTab} data-selected={true}>
            {draggingTabData.title}
          </div>
        </div>
      )}
      {draggingTabData?.type == 'visit' && (
        <VisitContent data={draggingTabData.visitData} />
      )}
    </DragOverlay>
  );
};
